(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["icon-with-text"] && !Shopify.designMode) return;
  try {
    (() => {
      const triggers = document.querySelectorAll('.icon-with-text__popup-trigger[data-popup-dialog-id]');
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const id = trigger.getAttribute('data-popup-dialog-id');
          if (!id) return;
          const dialog = document.getElementById(id);
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') dialog.showModal();
        });
      });

      document.querySelectorAll('dialog.icon-with-text__dialog').forEach((dialog) => {
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) dialog.close();
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
